import React from 'react';

import { Box, Paper, Typography } from '@mui/material';
import { Virtuoso } from 'react-virtuoso';
import { Operation } from 'src/types/operation';

import { FundItem } from './FundItem';
import { QuotaRecord } from '../AddFundsToWallet';

type OperationWithRecords = Operation & { quotas: QuotaRecord[] };

type VirtualizedSelectedFundsListProps = {
  funds: OperationWithRecords[];
  onRemoveFund: (hashId: string) => void;
  onAddRecord: (hashId: string) => void;
  onRemoveRecord: (hashId: string, quota: string, series: string) => void;
  onChangeRecord: (
    hashId: string,
    recordIndex: number,
    field: keyof QuotaRecord,
    value: string | number,
  ) => void;
};

export function VirtualizedSelectedFundsList({
  funds,
  onRemoveFund,
  onAddRecord,
  onRemoveRecord,
  onChangeRecord,
}: VirtualizedSelectedFundsListProps) {
  if (funds.length === 0) {
    return (
      <Paper variant="outlined" sx={{ p: 2, mb: 2, maxHeight: '450px' }}>
        <Typography variant="h6" sx={{ mb: 2 }}>
          Fundos Escolhidos (0)
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Nenhum fundo selecionado ainda.
        </Typography>
      </Paper>
    );
  }

  return (
    <Paper
      variant="outlined"
      sx={{
        p: 2,
        mb: 2,
        maxHeight: '450px',
        display: 'flex',
        flexDirection: 'column',
      }}>
      <Typography variant="h6" sx={{ mb: 2 }}>
        Fundos Escolhidos ({funds.length})
      </Typography>

      <Box sx={{ flex: 1, minHeight: 0 }}>
        <Virtuoso
          style={{
            height: '400px',
            scrollbarWidth: 'thin',
            scrollbarColor: '#888 #f1f1f1',
          }}
          data={funds}
          itemContent={(index, fund) => (
            <Box sx={{ px: 1, pb: 1 }}>
              <FundItem
                key={fund.hashId}
                fund={fund}
                fundIndex={index}
                onRemoveFund={onRemoveFund}
                onAddRecord={onAddRecord}
                onRemoveRecord={onRemoveRecord}
                onChangeRecord={onChangeRecord}
              />
            </Box>
          )}
          overscan={5}
        />
      </Box>
    </Paper>
  );
}
